import styled from 'styled-components'
import { Text } from '~/components/core'

export const StyledTitleText = styled(Text).attrs({ forwardedAs: 'span' })`
  max-width: 236px;
  text-overflow: ellipsis;
`

export const StyledSubtitleText = styled(Text).attrs({
  forwardedAs: 'span',
})`
  max-width: 286px;
  text-overflow: ellipsis;
`

export const NameWrapper = styled.span`
  display: flex;
  align-items: center;
  max-width: 240px;
  > span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const TitleMatch = styled.span`
  color: var(--chakra-colors-fg-default);
  font-weight: 700;
`
